module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && _vm.notice) ? _c('div', {
    staticClass: "page-notice"
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpNotice.apply(null, arguments)
      }
    }
  }, [_vm._v("[通知] " + _vm._s(_vm.notice))]), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeNotice.apply(null, arguments)
      }
    }
  }, [_vm._v("x")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e2d7fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice.vue
// module id = 506
// module chunks = 39